/**
 * Thrown when {@link mergeAppConfigs} encounters a malformed item in a registered
 * array path. It carries the registered key-path (for example `app.extensions`) and
 * the `context` of the contributing config, so the operator can locate the offending
 * file. It is thrown in place of the native `TypeError` that `Object.keys(null)` or a
 * similar operation would otherwise raise.
 */
export class ConfigMergeError extends Error {
  /** The `context` (source) of the contributing config that carried the item. */
  readonly configContext: string;

  /** The registered array path where the malformed item was found. */
  readonly keyPath: string;

  constructor(message: string, keyPath: string, configContext: string) {
    super(`${message} (path: ${keyPath}, context: ${configContext})`);
    this.name = 'ConfigMergeError';
    this.keyPath = keyPath;
    this.configContext = configContext;

    // Restore prototype chain for instanceof across transpilation targets.
    Object.setPrototypeOf(this, ConfigMergeError.prototype);
  }
}
